export default {
    table: (state) => state.pagination.data,
    pagination: (state) => state.pagination.pagination,
    loading: (state) => state.pagination.loading,
    selectedTab: (state) => state.pagination.selectedTab,
    selectedType: (state) => state.pagination.selectedType
}